export const selectors = {
  connections: (state) => state.profile.connections,
  loadingConnectionsAccounts: (state) =>
    state.profile.loadingConnectionsAccounts,
  pagination: (state) => state.profile.pagination,
  filters: (state) => state.profile.filters,
  userProfile: (state) => state.profile.userProfile,
  loadingProfile: (state) => state.profile.loadingProfile,
  loadingUpdateProfile: (state) => state.profile.loadingUpdateProfile,
};
